import { getTenantId } from 'src/app/services/store-snapshot.service';
import { Observable } from 'rxjs/internal/Observable';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ApiResponse } from 'src/app/core/models/api-response';
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { createFilterParams } from 'src/app/shared/functions/create-filter-params';
import { IEquivalentCompetencesModel } from 'src/app/competence/model/competence.model';
import { IAttachment } from '../../attachments/models/attachments.model';
import { ICompetenceUserModel } from '../models/competence-user.model';

const COLUMN_MAP = {
  registrationComplete: 'isRegistrationCompleted',
  selfAssignable: 'selfAssignable',
  expiry: 'expiresAt',
  statusCompetenceUser: 'statusType',
};

@Injectable({
  providedIn: 'root',
})
export class CompetenceUserApiService {
  private get baseUrl(): string {
    return `${environment.apiUrl}/api/${getTenantId()}/Competence/User`;
  }

  private readonly httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
    params: new HttpParams(),
  };

  constructor(private http: HttpClient) {}

  getUserCompetencesList(
    userId: string,
    currentFilter?: MainTableFilterModel
  ): Observable<ApiResponse<ICompetenceUserModel[]>> {
    const url = `${this.baseUrl}/${userId}`;
    const params = createFilterParams(currentFilter, undefined, COLUMN_MAP);

    return this.http.get<ApiResponse<ICompetenceUserModel[]>>(url, { params });
  }

  getMyUserCompetencesList(
    currentFilter?: MainTableFilterModel
  ): Observable<ApiResponse<ICompetenceUserModel[]>> {
    const url = `${this.baseUrl}/Me`;
    const params = createFilterParams(currentFilter, undefined, COLUMN_MAP);

    return this.http.get<ApiResponse<ICompetenceUserModel[]>>(url, { params });
  }

  getUserCompetenceById(userId: string, competenceId: string): Observable<ICompetenceUserModel> {
    const url = `${this.baseUrl}/${userId}/${competenceId}`;
    return this.http.get<ICompetenceUserModel>(url, this.httpOptions);
  }

  getUserEquivalentCompetences(
    userId: string,
    competenceId: string
  ): Observable<IEquivalentCompetencesModel> {
    const url = `${this.baseUrl}/${userId}/${competenceId}/equivalent`;
    return this.http.get<IEquivalentCompetencesModel>(url, this.httpOptions);
  }

  addUserCompetence(toAdd: FormData): Observable<any> {
    return this.http.post<any>(this.baseUrl, toAdd);
  }

  renewUserCompetence(toRenew: FormData): Observable<any> {
    const url = `${this.baseUrl}/Renew`;
    return this.http.put<any>(url, toRenew);
  }

  deleteUserCompetence(userId: string, competenceId: string): Observable<void> {
    const url = `${this.baseUrl}/${userId}/${competenceId}`;
    return this.http.delete<void>(url, this.httpOptions);
  }

  updateUserCompetence(
    toUpdate: FormData,
    userId: string,
    competenceId: string
  ): Observable<IAttachment[]> {
    const url = `${this.baseUrl}/${userId}/${competenceId}`;
    return this.http.put<IAttachment[]>(url, toUpdate);
  }
}
